module.exports = __webpack_public_path__ + "dd4cc1c8c5d007f2e64f0a6e1446dcc3.pdf";